import { useMediaQuery } from 'react-responsive';
import useEnvService from './useEnvService';

function useIsCompact() {
  const isSmall = useMediaQuery({ query: '(max-width: 992px)' });
  const [env] = useEnvService();

  return isSmall && env.app.isCompact;
}

export default useIsCompact;
